import { Stack } from "@braintrust/braintrust-ui-components";

import { FreelancerInvoicesLazy } from "../lazy";

import { FreelancerDashboardLayout } from "./layout";

export const FreelancerDashboardInvoicesPage = () => (
  <FreelancerDashboardLayout pageTitle="Invoices">
    <Stack sx={{ position: "relative", flexGrow: 1 }}>
      <FreelancerInvoicesLazy onlyMobileMenu />
    </Stack>
  </FreelancerDashboardLayout>
);
